@if (content) {
  <div class="row" [class.reverse]="content.alignment == 'reversed'">
    <div class="col-xs-12 col-md-4 image">
      @if (content.picture_tag_info) {
        <wagtail-page-element-image
          [image]="content.picture_tag_info"
          [width]="500"
        ></wagtail-page-element-image>
      }
    </div>
    <div class="col-xs-12 col-md-8 richtext">
      <div class="heading">{{ content.title }}</div>
      <div class="text" [innerHTML]="content.text | sanitize"></div>
    </div>
  </div>
}